import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { Modal } from 'components/atoms/modal';
import { toastService } from 'components/molecules/toast';
import { RoutePaths } from 'constant';
import { useTranslation } from 'hooks/use-translation';
import { useArchiveProjectMutation } from 'queries/project';

interface Props {
  projectId: number;
  projectName: string;
  closeModal: () => void;
  isVisible: boolean;
  redirectTo?: string;
}

export const ArchiveProjectModal: FC<Props> = ({
  projectId,
  projectName,
  closeModal,
  isVisible,
  redirectTo,
}) => {
  const history = useHistory();

  const { mutate: archiveProjMutate, isLoading: isArchiving } =
    useArchiveProjectMutation();

  const archiveTitle = useTranslation('project.action.archive.title');
  const archiveButtonText = useTranslation('archive');
  const archiveSuccessMessage = useTranslation(
    'project.action.archive.modal.archive.message',
    { projectName },
  );

  const archiveErrorTitle = useTranslation('error_action');
  const archiveErrorMessage = useTranslation('error');

  const handleProjectArchive = () => {
    archiveProjMutate(
      { projectId },
      {
        onSuccess: () => {
          toastService({
            title: archiveTitle,
            message: archiveSuccessMessage,
          }).success();
          closeModal();

          return history.push(redirectTo ?? RoutePaths.projects);
        },
        onError: () => {
          toastService({
            title: archiveErrorTitle,
            message: archiveErrorMessage,
          }).error();
        },
      },
    );
  };

  return (
    <Modal
      visible={isVisible}
      title={archiveTitle}
      okText={archiveButtonText}
      okButtonProps={{
        type: 'primary',
        name: 'project.action.archive.modal.confirm',
      }}
      onOk={handleProjectArchive}
      onCancel={closeModal}
      confirmLoading={isArchiving}
    >
      <FormattedMessage id="project.action.archive.modal.text" />
      <p>
        <FormattedMessage
          id="project.action.archive.modal.footer_confirm_text"
          values={{ b: () => <b>{projectName}</b> }}
        />
      </p>
    </Modal>
  );
};
